import { Formik, FormikConfig, FormikProps } from 'formik';
import { FV } from './share';
import { ReactNode, useMemo } from 'react';
import { StyledForm, getSlateExecuteContext } from 'views/Aide/Scenario/PolicyForm';
import Name from './Name';
import Enable from './Enable';
import TermOfValidity from './TermOfValidity';
import ReplyContent from './ReplyContent';
import OrderStatusField from 'views/Aide/Scenario/PolicyForm/OrderStatusField';
import { useGetPolicyName } from 'views/Aide/Scenario/NewPolicy/useGetPolicyName';
import { useTranslate } from '@tolgee/react';

export interface PolicyFormProps extends FormikConfig<FV> {
  platform?: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  policyList?: NightWatch.Policy[];
  editable?: boolean;
  children: (form: ReactNode, props: FormikProps<FV>) => ReactNode;
}

export const createDefaultInitialValues = (
  partial: Util.PartialRequired<Partial<FV>, 'fallbackId'>,
): FV => {
  return {
    name: '',
    enable: true,
    termOfValidity: { termType: 'LONG_TERM' },
    replyContent: [
      getSlateExecuteContext({
        content: '',
        translatedContent: '',
      }),
    ],
    limitOrderStatus: {
      enable: false,
      orderStatus: [],
    },
    ...partial,
  };
};

function PolicyForm(props: PolicyFormProps) {
  const {
    platform,
    region,
    policyList = [],
    editable,
    children,
    initialValues,
    ...otherProps
  } = props;

  const { t } = useTranslate();

  const { getPolicyName } = useGetPolicyName();

  return (
    <Formik
      enableReinitialize
      initialValues={useMemo(() => {
        return {
          ...initialValues,
          name: getPolicyName(initialValues.name),
        };
      }, [initialValues, getPolicyName])}
      {...otherProps}
    >
      {(props) => {
        const {
          values: { fallbackPolicyId, name },
        } = props;

        const form = (
          <StyledForm>
            <div>
              <h3>{t('aide.基础配置')}</h3>
              <Name policyList={policyList} editable={editable} />
              <Enable editable={editable} />
              <TermOfValidity editable={editable} />
              <OrderStatusField />
            </div>
            <div>
              <h3>{t('phrase.回复内容')}</h3>
              <ReplyContent
                key={`${fallbackPolicyId}-${Boolean(name)}`}
                platform={platform}
                region={region}
                editable={editable}
              />
            </div>
          </StyledForm>
        );

        return children(form, props);
      }}
    </Formik>
  );
}

export default PolicyForm;
